import { z } from "zod";

const patientSchema = z.object(
  {
    name: z.string(),
    id: z.string(),
    individualId: z.string().optional(),
  },
  {
    required_error: "page.schedules.newSchedule.steps.patient.error",
    invalid_type_error: "page.schedules.newSchedule.steps.patient.error",
  }
);

const insuranceSchema = z.object(
  {
    name: z.string().min(1, { message: "required" }),
    id: z.string().min(1),
    insuranceIntegrationId: z.string(),
  },
  { required_error: "page.schedules.newSchedule.steps.insurance.error" }
);

export const appointmentSchema = z.object({
  patient: patientSchema,
  insurance: insuranceSchema,
  anamnesis: z
    .string()
    .min(1, "page.triageEmergencyDepartment.error.anamnesis"),
});

export type TAppointment = z.infer<typeof appointmentSchema>;
